<ng-container>
  <!-- MP direction Summary-->
  <div class="v-center" style="font-size: 14px; gap: 4px; justify-content: end; padding: 8px 20px;"> 
    <div class="--g-tooltip-content" *ngIf="notApprovedCount" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
      <div class="not-approved-label small-font v-center" style="cursor: pointer;"><i class="material-icons-outlined" style="margin-right: 5px; font-size: 14px">edit</i>
        <div>Draft : {{notApprovedCount}}</div>
      </div>
      <div class="--g-tooltip tooltip-background">The current directions are still in draft status. When you are ready, you may approve these directions for review. Once you have approved them for review, the directions will show as “Pending” for further review and approval for display in the operator monitoring portal.</div>
    </div>
    <div class="--g-tooltip-content" *ngIf="approvalPendingCount" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
      <div class="pending-label small-font v-center" style="cursor: pointer;"><i class="material-icons-outlined" style="margin-right: 5px; font-size: 14px">schedule</i>
        <div>Approval Pending : {{approvalPendingCount}}</div>
      </div>
      <div class="--g-tooltip tooltip-background">These directions are waiting for approvals to be shown in the operator monitoring portal. Please review and approve it to ensure it’s visible to operators.</div>
    </div>
    <div class="--g-tooltip-content" *ngIf="finalizedCount" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
      <div class="finalized-label small-font v-center" style="cursor: pointer;"><i class="material-icons-outlined" style="margin-right: 5px; font-size: 14px">check_circle</i>
        <div>Finalized : {{finalizedCount}}</div>
      </div>
      <div class="--g-tooltip tooltip-background">The directions are finalized and visible to operators in the monitoring portal. If these directions are edited, the approval process must be completed again.</div>
    </div>
    <div class="--g-tooltip-content" *ngIf="deleteRequested" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
      <div class="delete-requested-label small-font v-center" style="cursor: pointer;"><i class="material-icons-outlined" style="margin-right: 5px; font-size: 14px">do_not_disturb_on</i>
        <div>Delete Requested : {{deleteRequested}}</div>
      </div>
      <div class="--g-tooltip tooltip-background">These directions are waiting for deleting to be hide in the operator monitoring portal. Please review and delete it to ensure it’s visible to operators.</div>
    </div>
    <div class="--g-tooltip-content" *ngIf="noContentCount" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
      <div class="default-label small-font">None : {{noContentCount}}</div>
      <div class="--g-tooltip tooltip-background">No Content</div>
    </div>
  </div>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-area" *ngIf="!isLoading" style="height: calc(100% - 35px);">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumnInMPDirections($event)">
        <colgroup>
          <col *ngFor="let col of mpDirectionTableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of mpDirectionTableHeader" [sortable-column]="header.value">
               {{header.name}}</th>
          </tr>
        </thead>
      </table>
      <div class="alternative-contents" *ngIf="determineElementToShowInMPDirection() === 'no-data'"> <i class="material-icons">inventory_2</i>
        <div>No Monitoring Portal Directions</div>
      </div>
      <div class="alternative-contents" *ngIf="determineElementToShowInMPDirection() === 'no-permission'"> <i class="material-icons">do_not_disturb_on</i>
        <div>Permission Denied</div>
      </div>
      <div class="table-body" style="max-height: calc(100% - 139px);" *ngIf="determineElementToShowInMPDirection() === 'normal'">
        <table>
          <colgroup>
            <col *ngFor="let col of mpDirectionTableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <ng-container *ngIf="!isLoading">
              <tr *ngFor="let direction of pagedItems">
                <td [class.no-contents]="direction.status === null">{{ direction.site_id }}</td>
                <td [class.no-contents]="direction.status === null"> 
                  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                    <div class="ellipsis">{{ direction.site_name }}</div>
                    <div class="--g-tooltip tooltip-background">{{ direction.site_name }}</div>
                  </div>
                </td>
                <td [class.no-contents]="direction.status === null">{{ direction.type }}</td>
                <td> 
                  <div class="v-center" [ngClass]="computedStatusLabelColor(direction)" [class.no-contents]="direction.status === null"> <i class="material-icons-outlined" style="margin-right: 5px; font-size: 14px" *ngIf="computedStatusLabelIcon(direction)">{{ computedStatusLabelIcon(direction) }}</i>
                    <div>{{ direction.statusLabel }}</div>
                  </div>
                </td>
                <td [class.no-contents]="direction.status === null"> 
                  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                    <div class="ellipsis">{{ direction.type === 'Site' ? '-' : direction.zone_number }}</div>
                    <div class="--g-tooltip tooltip-background">{{ direction.type === 'Site' ? '-' : direction.zone_number }}</div>
                  </div>
                </td>
                <td [class.unknown]="direction.name === 'No Name'" [class.no-contents]="direction.status === null"> 
                  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                    <div class="ellipsis">{{ direction.name }}</div>
                    <div class="--g-tooltip tooltip-background">{{ direction.name }}</div>
                  </div>
                </td>
                <td>
                  <div [class.need-to-check]="isNeedToCheck(direction?.site_owned_dealer_approved_by)" [class.no-contents]="direction.status === null" [class.approved_by_label]="computedMPDirectionStatusLabelColor(direction?.site_owned_dealer_approved_by)"> 
                    <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                      <div class="ellipsis">{{ direction.site_owned_dealer_approved_by }}</div>
                      <div class="--g-tooltip tooltip-background">{{ direction.site_owned_dealer_approved_by }}</div>
                    </div>
                  </div>
                </td>
                <td> 
                  <div [class.need-to-check]="isNeedToCheck(direction?.monitoring_operator_approved_by)" [class.no-contents]="direction.status === null" [class.approved_by_label]="computedMPDirectionStatusLabelColor(direction?.monitoring_operator_approved_by)"> 
                    <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')" style="margin: 0">
                      <div class="ellipsis">{{ direction.monitoring_operator_approved_by }}</div>
                      <div class="--g-tooltip tooltip-background">{{ direction.monitoring_operator_approved_by }}</div>
                    </div>
                  </div>
                </td>
                <td [class.no-contents]="direction.status === null">{{ direction.created_at ?? '-' }}</td>
                <td [class.no-contents]="direction.status === null">{{ direction.updated_at ?? '-' }}</td>
                <td>
                  <div class="more-content v-center" #directionActionMenus [id]="'direction-'+ direction.id" (mouseover)="setMorePosition(direction.id)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(direction)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [class.show]="direction.isShowMenu" [id]="'more-direction-'+direction.id">
                      <div class="more-item row" *ngIf="direction?.status != null" (click)="goToDirectionDetail($event, direction)">
                        <div>Go to Detail</div>
                      </div>
                      <div class="more-item row" *ngIf="direction?.status === null" (click)="goToAddDirectionDetail($event, direction)">
                        <div>Add Direction</div>
                      </div>
                      <div class="more-item text-primary row" *ngIf="doWeNeedApproveBtn(direction)" (click)="onClickApprove($event, direction)">
                        <div>{{ direction.isOwnSite || direction.isSiteMonitoringDealer ? 'Finalize' : 'Approve'}}</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- pagination-->
      <div class="pagination-area">
        <div style="font-size:12px;padding-right: 7px;"></div>
        <div class="space"></div>
        <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
          <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
          <div>of </div>
          <div>{{totalItem}}</div>
        </div>
        <div class="pagination">
          <div class="page-mover">
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
                <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
              </div>
            </div>
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
                <div class="btn-inner"><span>Next</span>
                  <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>